import styled from 'styled-components';

import { scale150, spaceL, xdlColorDisabledStrong, xdlColorHoverSecondary, xdlColorText } from '@xingternal/tokens';

export const Pagination = styled.ol`
  display: flex;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const ArrowLink = styled.a<{ $hidden?: boolean }>`
  align-items: center;
  color: ${xdlColorText};
  display: flex;
  font-size: ${spaceL};
  font-weight: bold;
  height: ${scale150};
  justify-content: center;
  width: ${scale150};

  cursor: ${({ $hidden }) => ($hidden ? 'default' : 'pointer')};
  user-select: ${({ $hidden }) => ($hidden ? 'none' : 'auto')};

  & {
    color: ${({ $hidden }) => ($hidden ? xdlColorDisabledStrong : 'unset')};
  }

  &:hover,
  &:focus {
    color: ${({ $hidden }) => ($hidden ? xdlColorDisabledStrong : xdlColorText)};
    background-color: ${({ $hidden }) => ($hidden ? 'transparent' : xdlColorHoverSecondary)};
    text-decoration: none;
    border-radius: 50%;
  }
`;
